import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchInvestmentConsensus } from '@apis/investmentIndicators';
import type { InvestmentConsensusApiData } from '@app-types/investmentIndicatorsApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

export const useInvestmentConsensus = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<InvestmentConsensusApiData>({
    queryKey: ['indicators', 'consensus', ticker, mkt],
    queryFn: () => fetchInvestmentConsensus({ ticker: ticker as string, mkt: mkt as string }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};

